import { setHiddenDefaultProductApi } from "@/api/services/global/master";
import { TGetDefaultProductListOutputDto } from "@/api/services/global/master/dtos/defaultProduct/get-master-default-product-list.dto";
import { Modal } from "@/components/elements/Modal";
import { API_SUCCESS_MESSAGE } from "@/constants/common";
import { QUERY_KEYS } from "@/constants/queryKeys";
import { showError } from "@/utils/error";
import { toNumber } from "@/utils/number";
import { toast } from "@/utils/toast";
import { Typography } from "@mui/material";
import { useQueryClient } from "@tanstack/react-query";
import { Dispatch, FC, SetStateAction } from "react";

type THiddenDefaultProductModalProps = {
  hiddenDefaultProduct?: TGetDefaultProductListOutputDto;
  setHiddenDefaultProduct: Dispatch<SetStateAction<TGetDefaultProductListOutputDto | undefined>>;
};

export const HiddenDefaultProductModal: FC<THiddenDefaultProductModalProps> = ({ hiddenDefaultProduct, setHiddenDefaultProduct }) => {
  const queryClient = useQueryClient();

  const handleSubmit = async () => {
    if (!hiddenDefaultProduct) return;
    try {
      await setHiddenDefaultProductApi(toNumber(hiddenDefaultProduct.id), { isHidden: !hiddenDefaultProduct.isHidden });
      toast.success(API_SUCCESS_MESSAGE);
      setHiddenDefaultProduct(undefined);
      queryClient.invalidateQueries({ queryKey: [QUERY_KEYS.GLOBAL.MASTER_DEFAULT_PRODUCT] });
    } catch (error) {
      showError(error);
    }
  };

  return (
    <Modal
      title={hiddenDefaultProduct?.isHidden ? "有効の確認" : "無効化の確認"}
      isOpen={!!hiddenDefaultProduct}
      onClose={() => setHiddenDefaultProduct(undefined)}
      enableCloseIcon={false}
      labelClose="キャンセル"
      labelOk="保存"
      onOk={() => handleSubmit()}
    >
      <Typography variant="body14" component="p" sx={{ paddingY: 2 }}>
        {hiddenDefaultProduct?.isHidden ? "この行が有効になれますが、よろしいですか。" : "この行が無効化されますが、よろしいですか。"}
      </Typography>
    </Modal>
  );
};
